import { Event } from '../../../types/event';
import { Membership } from '../../../types/membership';
import { Ticket } from '../../../types/ticket';
import { ValidationStrategy, ValidationResult } from './validationStrategy';

export class DefaultStrategy extends ValidationStrategy {
  shouldApply() {
    return true; // Sempre aplica se nenhuma outra estratégia for escolhida
  }

  validate(membershipApplied: Membership | null, cart: Ticket[], event: Event | null,
    tickets: Ticket[], groupId: number, ticketId: number, totalTickets: number): ValidationResult {
    const baseValidation = super.validate(membershipApplied, cart, event, tickets, groupId, ticketId, totalTickets);
    if (baseValidation.disableAddToCart) return baseValidation;

    const containsMoreThanMax = event && totalTickets >= event.attributes.cpfTicketsLimit.value;
    return { disableAddToCart : !!containsMoreThanMax, errorMessage : null };
  }
}
